// extracted by mini-css-extract-plugin
export default {"imgwhite":"header_imgwhite__G3iJY","aheader":"header_aheader__C-aWQ","links":"header_links__2vUmi","linktop":"header_linktop__NJRr1"};